import React from "react";
import { DirectH, FooterH, FooterStyle, IndentedDiv } from "style";

const Footer = () => {
  return (
    <div style={{ backgroundColor: "#006DAB" }}>
      <IndentedDiv>
        <FooterStyle>
          <DirectH $footer>Camper</DirectH>
          <FooterH>
            <div>Services</div>
            <div>Camping</div>
            <div>Lodging</div>
            <div>Harbor</div>
            <div>Day Use</div>
          </FooterH>
          <FooterH>
            <div>Menu</div>
            <div>About</div>
            <div>Services</div>
            <div>Booking</div>
            <div>Blog</div>
          </FooterH>
          <FooterH>
            <div>Contact</div>
            <div
              style={{
                display: "flex",
                columnGap: "10px",
                height: "26px",
                alignItems: "center",
              }}
            >
              <svg
                style={{ margin: "0" }}
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <g clipPath="url(#clip0_5737_597)">
                  <path
                    d="M24.8945 6.57247C24.7468 6.04462 24.4653 5.56384 24.0773 5.17668C23.6893 4.78951 23.208 4.5091 22.6798 4.36257C20.6971 3.83254 12.7269 3.83254 12.7269 3.83254C12.7269 3.83254 4.77171 3.81983 2.76841 4.36257C2.24109 4.50974 1.76064 4.79045 1.37352 5.17758C0.986394 5.5647 0.705681 6.04515 0.558513 6.57247C0.182011 8.60217 -0.00342187 10.6627 0.0046469 12.727C0.000973188 14.7814 0.186377 16.8317 0.558513 18.8521C0.706157 19.3797 0.986953 19.8605 1.37394 20.2483C1.76093 20.6361 2.24112 20.918 2.76841 21.0668C4.75105 21.5968 12.7269 21.5968 12.7269 21.5968C12.7269 21.5968 20.6773 21.5968 22.6798 21.0668C23.2079 20.9186 23.6891 20.6371 24.0769 20.2492C24.4648 19.8614 24.7463 19.3802 24.8945 18.8521C25.2592 16.8329 25.4372 14.7795 25.4245 12.727C25.4372 10.6609 25.2632 8.60438 24.8945 6.57247ZM10.1808 16.5309V8.90634L16.8153 12.727L10.1808 16.5309Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5737_597">
                    <rect width="25.4286" height="25.4286" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 21 22"
                fill="none"
              >
                <path
                  d="M10.4641 7.60483C8.59642 7.60483 7.07225 9.19254 7.07225 11.1381C7.07225 13.0836 8.59642 14.6713 10.4641 14.6713C12.3318 14.6713 13.856 13.0836 13.856 11.1381C13.856 9.19254 12.3318 7.60483 10.4641 7.60483ZM20.6371 11.1381C20.6371 9.67495 20.6499 8.22507 20.571 6.76459C20.4921 5.06821 20.1206 3.56267 18.9298 2.32219C17.7364 1.07906 16.2936 0.694719 14.6651 0.612551C13.2605 0.530382 11.8687 0.543635 10.4666 0.543635C9.06207 0.543635 7.67021 0.530382 6.26818 0.612551C4.63968 0.694719 3.19439 1.08171 2.00355 2.32219C0.810162 3.56532 0.441205 5.06821 0.362325 6.76459C0.283444 8.22773 0.296167 9.6776 0.296167 11.1381C0.296167 12.5986 0.283444 14.0511 0.362325 15.5116C0.441205 17.208 0.812706 18.7135 2.00355 19.954C3.19693 21.1971 4.63968 21.5814 6.26818 21.6636C7.67276 21.7458 9.06461 21.7325 10.4666 21.7325C11.8712 21.7325 13.2631 21.7458 14.6651 21.6636C16.2936 21.5814 17.7389 21.1945 18.9298 19.954C20.1231 18.7108 20.4921 17.208 20.571 15.5116C20.6524 14.0511 20.6371 12.6012 20.6371 11.1381ZM10.4641 16.5745C7.57606 16.5745 5.24528 14.1465 5.24528 11.1381C5.24528 8.12965 7.57606 5.7017 10.4641 5.7017C13.3521 5.7017 15.6829 8.12965 15.6829 11.1381C15.6829 14.1465 13.3521 16.5745 10.4641 16.5745ZM15.8967 6.74869C15.2224 6.74869 14.6778 6.18146 14.6778 5.47905C14.6778 4.77664 15.2224 4.20942 15.8967 4.20942C16.571 4.20942 17.1155 4.77664 17.1155 5.47905C17.1157 5.64584 17.0843 5.81104 17.0231 5.96517C16.962 6.1193 16.8722 6.25935 16.759 6.37729C16.6457 6.49523 16.5113 6.58874 16.3633 6.65247C16.2154 6.7162 16.0568 6.7489 15.8967 6.74869Z"
                  fill="white"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 20 21"
                fill="none"
              >
                <g clipPath="url(#clip0_5737_599)">
                  <path
                    d="M1.80457 0.542847C1.80457 0.542847 0.504883 0.542847 0.504883 1.89904V19.5295C0.504883 19.5295 0.504883 20.8857 1.80457 20.8857H18.7004C18.7004 20.8857 20.0001 20.8857 20.0001 19.5295V1.89904C20.0001 1.89904 20.0001 0.542847 18.7004 0.542847H1.80457ZM4.57858 5.28951H8.46138L12.0558 10.7634V5.28951H15.9264V16.139H12.0436L8.44919 10.666V16.139H4.57858V5.28951Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5737_599">
                    <rect
                      width="19.4952"
                      height="20.3429"
                      fill="white"
                      transform="translate(0.504883 0.542847)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div>021 Korea Seoul, LA</div>
            <div>camper@example.com</div>
            <div>(021) 345-6789-99</div>
          </FooterH>
        </FooterStyle>
      </IndentedDiv>
    </div>
  );
};

export default Footer;
